import { Card, CardBody, Col } from 'reactstrap'
import { HelperCards } from '../../../../utils/Constant'
import { helperData } from '../../../../Data/Ui-Kits/Dropdown/Dropdown'
import HelperCart from './HelperCart'
import WarningCard from './WarningCard'
import AlertCard from './AlertCard'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const HelperCard = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={HelperCards} span={helperData} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            <HelperCart />
            <WarningCard />
            <AlertCard />
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default HelperCard